import "core-js/modules/es.error.cause.js";
import "core-js/modules/es.array.push.js";
import "core-js/modules/es.iterator.constructor.js";
import "core-js/modules/es.iterator.filter.js";
import "core-js/modules/es.iterator.find.js";
import "core-js/modules/es.iterator.for-each.js";
import "core-js/modules/es.iterator.map.js";
import topTitle from '@/components/title';
import { agencyDetail, agencyLevelList, uploadFile, addAgency, editAgency } from './request';
import { unitResource } from './../underwritingManage/request';
import { intermediaryList } from './../agencyManage/request';
import { cryptoDecrypt } from '@/utils/aes';
import { checkEmail } from '@/utils/validate';
import clipboard from '@/utils/clipboard';
import { filesResource } from '../filesManage/request';
// import LineString from '_ol@6.9.0@ol/geom/LineString'
export default {
  components: {
    topTitle
  },
  data() {
    return {
      remindList: [{
        name: '客户告知书',
        key: 'CUSTOMER_NOTIFICATION'
      }, {
        name: '隐私政策',
        key: 'PRIVACY_POLICY'
      }, {
        name: '投保须知',
        key: 'NOTICE_TO_INSURE'
      }, {
        name: '用户协议',
        key: 'USER_AGREEMENT'
      }, {
        name: '责任免除',
        key: 'DISCLAIMER_AGREEMENT'
      }],
      headers: {
        'X-Dispatch': 'Upload',
        'X-Version': 'upload'
      },
      action: uploadFile,
      unitList: [],
      ccList: [{
        cc: ''
      }],
      cycle: [],
      intermediaryList: [],
      agencyLevelList: [],
      form: {
        unitId: Number(this.$route.params.unit),
        sendAt: '',
        agencyId: this.$route.params.agency == -1 ? '' : Number(this.$route.params.agency),
        insuranceReminder: ''
      },
      fileList: [],
      email: 'validating',
      cycleType: 'validating',
      sendAtType: 'validating',
      templateUrlType: 'validating',
      showRemind: [],
      fileVisible: false,
      columns: [{
        slots: {
          title: '文件名称'
        },
        dataIndex: 'name',
        key: 'name',
        align: 'center'
      }, {
        slots: {
          title: '文件备注'
        },
        dataIndex: 'remark',
        key: 'remark',
        align: 'center'
      }, {
        slots: {
          title: '操作'
        },
        dataIndex: 'operation',
        key: 'operation',
        align: 'center',
        width: 100,
        scopedSlots: {
          customRender: 'operation'
        }
      }],
      data: [{
        name: 1,
        checked: false
      }, {
        name: 2,
        checked: false
      }, {
        name: 3,
        checked: false
      }]
    };
  },
  computed: {
    rules() {
      return {
        name: [{
          required: true,
          message: this.$t('请输入') + this.$t('机构全称'),
          trigger: 'blur'
        }],
        unitId: [{
          required: true,
          message: this.$t('请选择') + this.$t('承保单位'),
          trigger: 'change'
        }],
        level: [{
          required: true,
          message: this.$t('请选择') + this.$t('机构级别'),
          trigger: 'change'
        }],
        intermediaryId: [{
          required: true,
          message: this.$t('请选择') + this.$t('中介机构'),
          trigger: 'change'
        }],
        remind: [{
          required: true,
          validator: this.validateRemind
        }]
      };
    }
  },
  created() {
    unitResource({}).then(res => {
      console.log(res, 555);
      this.unitList = res;
    });
    intermediaryList({
      type: 0
    }).then(res => {
      console.log(res, 444);
      this.intermediaryList = res;
    });
    if (this.$route.params.id != -1) {
      agencyDetail({
        agencyId: this.$route.params.id
      }).then(res => {
        console.log(res, 5866);
        this.cycle = res.cycle;
        this.ccList = res.cc.length != 0 ? res.cc : [{
          cc: ''
        }];
        this.form = {
          unitId: res.unitId,
          agencyId: res.agencyId || this.$route.params.agency,
          email: res.email,
          templateUrl: res.templateUrl,
          name: res.name,
          sendAt: res.sendAt,
          intermediaryId: res.intermediaryId,
          level: res.level,
          insuranceReminder: res.insuranceReminder
        };
        this.showRemind = this.editShowRemindData(res.document);
        if (res.templateUrl) {
          this.fileList = [{
            uid: '1',
            name: res.templateName,
            status: 'done',
            url: res.templateUrl
          }];
        }
      });
    }
    if (this.$route.params.level != -1) {
      if (this.$route.params.id != -1) {
        this.agencyLevelList = agencyLevelList.filter(item => item.id >= this.$route.params.level);
      } else {
        this.agencyLevelList = agencyLevelList.filter(item => item.id > this.$route.params.level);
      }
      console.log(this.agencyLevelList);
    } else {
      this.agencyLevelList = agencyLevelList;
    }
  },
  methods: {
    validateRemind(rule, value, callback) {
      if (this.showRemind.length) {
        let rres = this.showRemind.find(item => !item.id);
        if (rres) {
          callback(new Error(this.$t('请配置变量阅读文件')));
        } else {
          callback();
        }
      } else {
        callback();
      }
    },
    editShowRemindData(data) {
      let arr = [];
      for (const key in data) {
        let res = this.remindList.find(item => item.key == key);
        if (res) {
          arr.push(Object.assign({
            remind: res.name,
            key: res.key
          }, data[key][0]));
        }
      }
      return arr;
    },
    async onAddFile(i) {
      const res = await filesResource({
        unitId: this.form.unitId,
        type: this.showRemind[i].key
      });
      this.data = res.map(item => {
        item.checked = false;
        return item;
      });
      this.currentFileIndex = i;
      this.fileVisible = true;
    },
    saveFile() {
      let res = this.data.find(item => item.checked);
      if (res) {
        this.showRemind[this.currentFileIndex].id = res.id;
        this.showRemind[this.currentFileIndex].name = res.name;
        this.showRemind[this.currentFileIndex].remark = res.remark;
        this.fileVisible = false;
      } else {
        return this.$message.warn(this.$t('请选择') + this.$t('文件'));
      }
    },
    onChangeFile(record, i) {
      record.checked = true;
      this.data = this.data.map((item, index) => {
        if (index !== i) {
          item.checked = false;
        }
        return item;
      });
    },
    onChangeRemind() {
      this.remindList.map(item => {
        if (this.form.insuranceReminder.includes(`《${item.name}》`) && !this.showRemind.find(i => i.key == item.key)) {
          this.showRemind.push({
            remind: item.name,
            key: item.key,
            remark: '',
            checked: false
          });
        }
      });
      this.showRemind = this.showRemind.filter((item, index) => this.form.insuranceReminder.includes(`《${item.remind}》`));
    },
    delFile(info, i) {
      this.showRemind[i].name = undefined;
      this.showRemind[i].remark = undefined;
      this.showRemind[i].id = undefined;
      // this.form.insuranceReminder = this.form.insuranceReminder.replaceAll('《' + info.remind + '》', '');
    },
    handleCopy(item, event) {
      clipboard(item, event, false);
      this.$message.success(this.$t('复制成功'));
    },
    handleAdd() {
      this.ccList.push({
        cc: ''
      });
    },
    handleDel(index) {
      this.ccList.splice(index, 1);
    },
    beforeUpload(file, fileList) {
      console.log(fileList);
      if (this.fileList.length > 1) {
        this.$message.error(this.$t('只能上传一个文件'));
        return false;
      }
    },
    handleChange(info) {
      console.log(info);
      if (info.file.status === 'done') {
        this.$message.success(`${info.file.name} ` + this.$t('上传成功'));
        let data = process.env.NODE_ENV === 'production' ? cryptoDecrypt(info.file.response.data) : info.file.response.data;
        console.log(data);
        this.form.templateUrl = data.fileTempUrl;
      } else if (info.file.status === 'error') {
        this.$message.error(`${info.file.name} ` + this.$t('上传失败'));
      } else if (info.file.status === 'removed') {
        this.form.templateUrl = '';
      }
      this.fileList = info.fileList.length != 0 ? [info.fileList[info.fileList.length - 1]] : [];
    },
    onChange(time, timeString) {
      console.log(time);
      this.form.sendAt = timeString;
    },
    onSubmit() {
      this.$refs.ruleForm.validate(valid => {
        if (valid) {
          if (this.showRemind.length) {
            let arr = [];
            this.showRemind.forEach(item => {
              if (item.id) {
                arr.push(item.id);
              }
            });
            this.form.readFileId = arr.join(',');
          }
          let adopt = true;
          if (this.form.email) {
            if (!checkEmail(this.form.email)) {
              adopt = false;
              this.email = 'error';
            } else {
              this.email = 'validating';
              adopt = true;
            }
            if (this.cycle.length == 0) {
              adopt = false;
              this.cycleType = 'error';
            } else {
              this.cycleType = 'validating';
              adopt = true;
            }
            if (!this.form.sendAt) {
              adopt = false;
              this.sendAtType = 'error';
            } else {
              this.sendAtType = 'validating';
              adopt = true;
            }
            if (!this.form.templateUrl) {
              adopt = false;
              this.templateUrlType = 'error';
            } else {
              this.templateUrlType = 'validating';
              adopt = true;
            }
          } else {
            this.email = 'validating';
            this.cycleType = 'validating';
            this.sendAtType = 'validating';
            this.templateUrlType = 'validating';
          }
          if (!adopt) {
            return false;
          }
          if (this.cycle.length != 0) {
            this.form.cycle = this.cycle.join(',');
          }
          let arr = this.ccList.filter(item => item.cc);
          if (arr.length != 0) {
            this.form.cc = JSON.stringify(arr);
          }
          let fun = this.$route.params.id == -1 ? addAgency : editAgency;
          fun(this.form).then(res => {
            // this.$message.config({maxCount: 1});
            this.$message.destroy();
            this.$message.success(this.$t('操作成功') + '!');
            this.$router.go(-1);
          });
        }
      });
    }
  }
};